import { post } from "../util/request";
export const joinInvestmentData = (form) => {
  return post("/platform/website/affiliation-intention", form)
}
export const businessCooperationData = (form) => {
  return post("/platform/website/business-cooperation", form)
}
export const cooperationInformationData = (form) => {
  return post("/platform/website/cooperation-information", form)
}


// WEBPACK FOOTER //
// ./src/api/affiliationIntention.js